import React = require('react')
import { HttpResult, none, some } from 'widgets-for-react'
import { EventsConfig } from '../../Shared/components/Events/EventState'
import { JumboProps } from '../../Shared/components/Jumbo/Jumbo'
import { node_parser } from '../../Shared/api/drupal/parser'
import { getPage } from '../custom_api/api'
import { activityDetailPage, generalContentPageBlocks } from '../custom_api/drupal_node_conversion'
import { Jumbo } from '../custom_components/components/jumbo'
import { ActivityDetailPage } from '../custom_components/pages/activity_detail_page'
import { EventBlocks } from '../../Shared/components/Events/EventDetails/EventDetailsState'
import { BlockRenderer } from '../custom_components/components/block_renderer'

export const fetchEventsOverviewJumboAanZet: () => Promise<HttpResult<JumboProps>> = async () => {
  const page = await getPage('/activiteiten', '')
  const result: JumboProps = (page == 'error' || page == 'loading') ? fallback : {
    title: page.headerTitle,
    contents: page.description,
    imageUrl: page.imageUrl,
    imageUrlLarge: page.imageUrl,
    imageAlt: page.imageAlt,
    size: 'large'
  }

  return { kind: 'result', value: result, status: 200 }
}

const fallback: JumboProps = {
  title: 'Activiteiten',
  contents: 'Doe mee!',
  imageUrl: '',
  imageUrlLarge: '',
  imageAlt: '',
  size: 'large'
}

export const renderAanZetJumbo = (props: JumboProps) => Jumbo({ ...props, headerImageUrl: props.imageUrl, headerImageAlt: props.imageAlt, headerTitle: props.title })

export const maybeRenderAanZetCmsPage: EventsConfig['renderCustomCmsPage'] = (cmsContent: any) => {
  if (!cmsContent) return none()

  const n = node_parser(cmsContent)
  if (n.bundle != 'activity_detail') return none()

  return some(<ActivityDetailPage {...activityDetailPage(n)} />)
}

export const AanZetEventBlocks = (props: { blocks: EventBlocks }) => <BlockRenderer blocks={generalContentPageBlocks(props.blocks)} />
